export enum FirebaseErrorCode {
    emailAlreadyInUse = "auth/email-already-in-use",
    weakPassword = "auth/weak-password",
    manyRequests = "auth/too-many-requests",
    tooManyAttempts = "auth/too-many-attempts",
    invalidCredential = "auth/invalid-credential",
    wrongPassword = "auth/wrong-password",
    userNotFound = "auth/user-not-found",
    invalidEmail = "auth/invalid-email",
    invalidInvite = "auth/invalid-invite",
    forbiddenInvite = "auth/forbidden-invite",
    inappropriateInvite = "aith/inappropriate-invite",
    accessPermissions = "auth/access-permissions",
    invalidProvider = "auth/account-exists-with-different-credential",
    cancelPopup = "auth/cancelled-popup-request",
    closePopup = "auth/popup-closed-by-user",
    verificationEmailFailed = "auth/verification-email-failed"
}
